(function () {
  if (window.__MILA_CTA_TRACKER__) return;
  window.__MILA_CTA_TRACKER__ = true;
  var DEBUG_STORAGE_KEY = "mila_cta_tracker_debug_bundle";
  var NAVIGATION_TIMEOUT_MS = 1000;

  function persistDebugBundle(bundle) {
    try {
      localStorage.setItem(DEBUG_STORAGE_KEY, JSON.stringify(bundle));
    } catch (error) {}
  }

  function logPreviousDebugBundle() {
    try {
      var raw = localStorage.getItem(DEBUG_STORAGE_KEY);
      if (!raw) return;

      var bundle = JSON.parse(raw);
      if (!bundle || !bundle.click_payload) return;
    } catch (error) {}
  }

  function getButtonText(element) {
    if (!element) return "";
    return (element.getAttribute("data-mila-button-text") || element.textContent || "").replace(/\s+/g, " ").trim();
  }

  function getTargetUrl(element) {
    if (!element) return "";
    return element.getAttribute("data-mila-target-url") || element.getAttribute("href") || "";
  }

  function isModifiedClick(event) {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
  }

  function buildPayload(element) {
    var data = element.dataset || {};
    var pageType = data.milaPageType || "";
    var buttonLocation = data.milaButtonLocation || "";
    var buttonType = data.milaButtonType || "";
    var payload = {
      event: "cta_click",
      page_type: pageType,
      button_location: buttonLocation,
      button_type: buttonType,
      button_text: getButtonText(element),
      target_url: getTargetUrl(element),
      product_handle: data.milaProductHandle || "",
      product_title: data.milaProductTitle || "",
      collection_handle: data.milaCollectionHandle || "",
      collection_title: data.milaCollectionTitle || "",
      click_context: [pageType, buttonLocation, buttonType].filter(Boolean).join("::")
    };

    Object.keys(payload).forEach(function (key) {
      if (payload[key] === "" || payload[key] == null) {
        delete payload[key];
      }
    });

    return payload;
  }

  function buildGA4Params(payload) {
    var params = {
      page_type: payload.page_type,
      button_location: payload.button_location,
      button_type: payload.button_type,
      button_text: payload.button_text,
      target_url: payload.target_url,
      click_context: payload.click_context,
      product_handle: payload.product_handle,
      product_title: payload.product_title,
      collection_handle: payload.collection_handle,
      collection_title: payload.collection_title
    };

    Object.keys(params).forEach(function (key) {
      if (params[key] === "" || params[key] == null) {
        delete params[key];
      }
    });

    return params;
  }

  function trackGA4(payload, callback) {
    var params = buildGA4Params(payload);
    var callbackFired = false;

    function safeCallback() {
      if (callbackFired) return;
      callbackFired = true;
      if (typeof callback === "function") callback();
    }

    try {
      if (typeof window.gtag === "function") {
        params.event_callback = safeCallback;
        window.gtag("event", "cta_click", params);
        setTimeout(safeCallback, NAVIGATION_TIMEOUT_MS);
        return { status: "sent", method: "gtag" };
      }
    } catch (error) {}

    safeCallback();
    return { status: "not_available", method: "none" };
  }

  function pushToDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    Array.prototype.push.call(window.dataLayer, payload);
  }

  function dispatchCustomEvent(payload, element) {
    try {
      document.dispatchEvent(new CustomEvent("mila:cta-click", {
        detail: {
          payload: payload,
          element: element
        }
      }));
    } catch (error) {}
  }

  function continueNavigation(element) {
    var href = getTargetUrl(element);
    if (!href || href === "#") return;
    window.location.href = href;
  }

  document.addEventListener("click", function (event) {
    var trackedElement = event.target.closest("[data-mila-track='cta-click']");
    if (!trackedElement) return;

    var href = getTargetUrl(trackedElement);
    var shouldDelayNavigation = trackedElement.tagName === "A" && href && href !== "#" && !isModifiedClick(event);

    if (shouldDelayNavigation) {
      event.preventDefault();
    }

    var payload = buildPayload(trackedElement);
    pushToDataLayer(payload);

    var navigationCallback = shouldDelayNavigation
      ? function () { continueNavigation(trackedElement); }
      : null;

    var gaResult = trackGA4(payload, navigationCallback);

    persistDebugBundle({
      timestamp: Date.now(),
      source_page_url: window.location.href,
      target_url: href || "",
      click_payload: payload,
      ga_status: gaResult
    });
    dispatchCustomEvent(payload, trackedElement);
  }, true);

  logPreviousDebugBundle();
})();
